import React, { Component } from 'react';

class CookieConsent extends Component {
  constructor(props) {
    super(props);
    var consent = localStorage.getItem('primal_cookie_consent');
    this.state = {
      visible: !consent,
      expanded: false,
      analyticsEnabled: true,
    };
    this.handleAcceptAll = this.handleAcceptAll.bind(this);
    this.handleSavePreferences = this.handleSavePreferences.bind(this);
    this.handleManage = this.handleManage.bind(this);
    this.handleToggleAnalytics = this.handleToggleAnalytics.bind(this);
    this._handleShowBanner = this._handleShowBanner.bind(this);
  }

  componentDidMount() {
    window.addEventListener('showCookieConsent', this._handleShowBanner);
  }

  componentWillUnmount() {
    window.removeEventListener('showCookieConsent', this._handleShowBanner);
  }

  _handleShowBanner() {
    var currentConsent = localStorage.getItem('primal_cookie_consent');
    this.setState({
      visible: true,
      expanded: true,
      analyticsEnabled: currentConsent !== 'essential',
    });
  }

  handleAcceptAll() {
    localStorage.setItem('primal_cookie_consent', 'all');
    this.setState({ visible: false });
    window.dispatchEvent(new CustomEvent('cookieConsentChanged', { detail: { consent: 'all' } }));
  }

  handleSavePreferences() {
    var consent = this.state.analyticsEnabled ? 'all' : 'essential';
    localStorage.setItem('primal_cookie_consent', consent);
    this.setState({ visible: false });
    window.dispatchEvent(new CustomEvent('cookieConsentChanged', { detail: { consent: consent } }));
  }

  handleManage() {
    this.setState({ expanded: !this.state.expanded });
  }

  handleToggleAnalytics() {
    this.setState({ analyticsEnabled: !this.state.analyticsEnabled });
  }

  render() {
    if (!this.state.visible) return null;

    return (
      <div
        className="tw-fixed tw-left-0 tw-right-0 tw-z-50 tw-p-4"
        style={{ pointerEvents: 'none', bottom: window.innerWidth < 768 ? '60px' : '0px' }}
      >
        <div
          className="tw-max-w-lg tw-mx-auto tw-bg-white dark:tw-bg-[#1a1a1a] tw-rounded-2xl tw-border tw-border-[#e0e0e0] dark:tw-border-[#333] tw-p-5"
          style={{ boxShadow: '0 -4px 24px rgba(0,0,0,0.12)', pointerEvents: 'auto' }}
        >
          <div className="tw-flex tw-items-start tw-gap-3 tw-mb-3">
            <div
              className="tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-mt-0.5"
              style={{ backgroundColor: 'rgba(201,168,76,0.1)', color: '#c9a84c' }}
            >
              <span role="img" aria-label="cookie" style={{ fontSize: '16px' }}>🍪</span>
            </div>
            <div>
              <p className="tw-text-sm tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-mb-1">
                Cookie Preferences
              </p>
              <p className="tw-text-xs tw-text-[#666] dark:tw-text-gray-400 tw-mb-0 tw-leading-relaxed">
                We use essential cookies for authentication and cart functionality. Analytics cookies help us improve the platform.{' '}
                <a href="/privacy#cookies" className="tw-text-brand-gold hover:tw-underline">Learn more</a>
              </p>
            </div>
          </div>

          {/* Expanded preferences */}
          {this.state.expanded && (
            <div className="tw-mb-4 tw-space-y-3 tw-pl-11">
              {/* Essential - always on */}
              <div className="tw-flex tw-items-center tw-justify-between tw-text-sm">
                <div>
                  <span className="tw-font-medium tw-text-[#1a1a1a] dark:tw-text-white">Essential Cookies</span>
                  <p className="tw-text-xs tw-text-[#888] dark:tw-text-gray-500 tw-mb-0">Authentication, cart, theme. Always active.</p>
                </div>
                <div
                  className="tw-w-10 tw-h-5 tw-rounded-full tw-flex tw-items-center tw-px-0.5 tw-cursor-not-allowed tw-opacity-60"
                  style={{ backgroundColor: '#c9a84c' }}
                >
                  <div className="tw-w-4 tw-h-4 tw-bg-white tw-rounded-full tw-ml-auto" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} />
                </div>
              </div>

              {/* Analytics - toggleable */}
              <div className="tw-flex tw-items-center tw-justify-between tw-text-sm">
                <div>
                  <span className="tw-font-medium tw-text-[#1a1a1a] dark:tw-text-white">Analytics Cookies</span>
                  <p className="tw-text-xs tw-text-[#888] dark:tw-text-gray-500 tw-mb-0">Mixpanel — helps us improve the platform.</p>
                </div>
                <button
                  onClick={this.handleToggleAnalytics}
                  className="tw-w-10 tw-h-5 tw-rounded-full tw-flex tw-items-center tw-px-0.5 tw-border-0 tw-cursor-pointer tw-transition-colors"
                  style={{ backgroundColor: this.state.analyticsEnabled ? '#c9a84c' : '#ccc' }}
                >
                  <div
                    className="tw-w-4 tw-h-4 tw-bg-white tw-rounded-full tw-transition-all"
                    style={{
                      marginLeft: this.state.analyticsEnabled ? 'auto' : '0',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                    }}
                  />
                </button>
              </div>
            </div>
          )}

          {/* Buttons */}
          <div className="tw-flex tw-items-center tw-gap-2 tw-pl-11">
            {!this.state.expanded ? (
              <>
                <button
                  onClick={this.handleAcceptAll}
                  className="tw-flex-1 tw-text-sm tw-font-semibold tw-text-white tw-border-0 tw-rounded-lg tw-py-2 tw-px-4 tw-cursor-pointer tw-transition-opacity hover:tw-opacity-90"
                  style={{ backgroundColor: '#c9a84c' }}
                >
                  Accept All
                </button>
                <button
                  onClick={this.handleManage}
                  className="tw-flex-1 tw-text-sm tw-font-semibold tw-text-[#666] dark:tw-text-gray-400 tw-bg-transparent tw-border tw-border-[#ddd] dark:tw-border-[#444] tw-rounded-lg tw-py-2 tw-px-4 tw-cursor-pointer tw-transition-colors hover:tw-border-[#999] dark:hover:tw-border-[#666]"
                >
                  Manage
                </button>
              </>
            ) : (
              <button
                onClick={this.handleSavePreferences}
                className="tw-flex-1 tw-text-sm tw-font-semibold tw-text-white tw-border-0 tw-rounded-lg tw-py-2 tw-px-4 tw-cursor-pointer tw-transition-opacity hover:tw-opacity-90"
                style={{ backgroundColor: '#c9a84c' }}
              >
                Save Preferences
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default CookieConsent;
